<div class="list-product-header">
    <div>
        <div class="light-box" (click)="showHideFilter()">
            <a>
                <app-feather-icons [class]="'filter-icon'" [ngClass]="!isOpen ?'show' :'hide'"
                                   [icons]="'filter'"></app-feather-icons>
                <i class="icon-close filter-close show" [ngClass]="isOpen ? 'show' : 'hide'"></i>
            </a>
        </div>
        <a *ngIf="!omiteBtnNew.includes(configuration.title)" class="btn btn-primary" (click)="add()"><i class="fa fa-plus"></i>{{configuration.title}}</a>
    </div>
    <div class="collapse" id="collapseProduct" [class.show]="isOpen">
        <div class="card card-body list-product-body">
            <div class="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 row-cols-xl-5 g-3">
                <!-- Columna de selección de columna -->
                <div class="col">
                    <label for="columnSelect">Columna</label>
                    <select
                            id="columnSelect"
                            class="form-select"
                            [(ngModel)]="filter.column"
                    >
                        <option value="" disabled selected>Selecciona una columna</option>
                        <option *ngFor="let option of columns" [ngValue]="option">
                            {{ option.title }}
                        </option>
                    </select>
                </div>

                <!-- Columna de selección de operador -->
                <div class="col">
                    <label for="operatorSelect">Operador</label>
                    <select
                            id="operatorSelect"
                            class="form-select"
                            [(ngModel)]="filter.operator"
                    >
                        <option value="" disabled selected>Seleccione</option>
                        <option *ngFor="let option of operators" [ngValue]="option">
                            {{ option.value }}
                        </option>
                    </select>
                </div>

                <!-- Columna de valor de filtro -->
                <div class="col">
                    <label for="filterValue">Valor</label>
                    <input
                            id="filterValue"
                            class="form-control"
                            [type]="(filter.operator == '>=' || filter.operator == '<=') ? 'number' : 'text'"
                            [(ngModel)]="filter.value"
                    />
                </div>

                <!-- Columna para el ícono de búsqueda -->
                <div class="col d-flex align-items-center gap-2">
                    <!-- Botón de agregar -->
                    <a class="link-with-icon d-flex align-items-center" (click)="addFilter()">
                        <i class="feather-icon me-1" data-feather="plus-circle"></i> Agregar
                    </a>

                    <!-- Botón de buscar -->
                    <a class="link-with-icon d-flex align-items-center" (click)="applyFilter()">
                        <i class="feather-icon me-1" data-feather="search"></i> Aplicar
                    </a>

                </div>

            </div>


            <h6 class="my-3" *ngIf="filters.length > 0">Filtros activos</h6>
            <div class="row g-3 mt-1 f-light" *ngFor="let filter of filters; let i = index">

                <!-- Columna de selección de columna -->
                <div class="col-auto">
                    <label for="columnSelect">{{ filter.column.title }}</label>
                </div>

                <!-- Columna de selección de operador -->
                <div class="col-auto">
                    <label for="operatorSelect">{{ filter.operator.value }} </label>
                </div>

                <!-- Columna de valor de filtro -->
                <div class="col-auto">
                    <label for="filterValue">{{ filter.value }}</label>
                </div>

                <!-- Columna para el ícono de búsqueda -->
                <div class="col d-flex align-items-center mt-2">
                    <a class="text-danger p-0" (click)="removeFilter(i)">
                        <i class="fa fa-trash"></i></a>
                </div>
            </div>

        </div>
    </div>
</div>
